import type { FormConfig, Question } from '../../types';
import type { ManagedField } from '../../../service/managed-options';

export function applyManagedPathways(config: FormConfig, fields: ManagedField[]): FormConfig {
  const field = fields.find((item) => item.field === 'gfie-pathways' && item.revision > 0);
  if (!field) return config;
  const records = field.options;
  const answerFieldsByOption = Object.fromEntries(
    records.map((row) => [row.value, `gfie-pathway-cross-government-${row.metadata.key}`]),
  );
  const questions: Question[] = config.sections.flatMap((section) =>
    section.subsections.flatMap((subsection) => {
      subsection.notRequiredWhen?.forEach((rule) => {
        if (rule.field === field.field && 'answerFieldsByOption' in rule)
          rule.answerFieldsByOption = answerFieldsByOption;
      });
      return subsection.pages.flatMap((page) =>
        page.pageType === 'question' ? page.questions || [] : [],
      );
    }),
  );
  for (const question of questions) {
    if (question.name === field.field) {
      question.options = records.map((row) => ({
        option: row.value,
        retired: Boolean(row.retired),
        questions: [
          {
            questionType: 'radio',
            title: 'Is this a cross-government pathway?',
            hint: 'Can other government departments use this pathway?',
            name: answerFieldsByOption[row.value],
            options: ['Yes', 'No'],
            defaultValue: row.metadata.crossGovernmentDefault ? 'Yes' : 'No',
            rules: { required: true },
          },
        ],
      }));
    }
    const table = question.dynamicTable;
    if (table?.rowFilter?.field === field.field) {
      table.rows = [
        ...records.map((row) => ({ key: row.metadata.key!, label: row.value })),
        ...table.rows.filter((row) => row.calculation),
      ];
    }
    if (table?.rowHeaderInput?.optionsFrom?.selectionField === field.field) {
      table.rowHeaderInput.optionsFrom.answerFieldsByOption = answerFieldsByOption;
      table.rowHeaderInput.dropdownOptions = records
        .filter((row) => !row.retired)
        .map((row) => row.value);
    }
  }
  return config;
}
